import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { AuthProvider } from './providers/auth';

ReactDOM.render(
  <React.Fragment>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.Fragment>,
  document.getElementById('root'),
  window.addEventListener("beforeunload", (ev) => 
{  
  let pathname = window.location.pathname; 
  // console.log(pathname);
  if(pathname !== '/login' && process.env.REACT_APP_ENV !== 'local'){
    if(localStorage.getItem('user') !== null){
      localStorage.clear()
    }
  }
  
  //return ev.returnValue = 'oi'
})
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
